
let dropdownData = [
    {name : "Products", dropdownItemData : [
      {img : "logo", title: "Product One", description: "This is the description one"},
      {img : "logo", title: "Product Two", description: "This is the description two"},
      {img : "logo", title: "Product Three", description: "This is the description three"},
      {img : "logo", title: "Product Two", description: "This is the description two"},
      {img : "logo", title: "Product Three", description: "This is the description three"},
      {img : "logo", title: "Product Two", description: "This is the description two"},
      {img : "logo", title: "Product Three", description: "This is the description three"},
      {img : "logo", title: "Product Two", description: "This is the description two"},
      {img : "logo", title: "Product Three", description: "This is the description three"},
      {img : "logo", title: "Product Two", description: "This is the description two"},
      {img : "logo", title: "Product Three", description: "This is the description three"},
      {img : "logo", title: "Product Two", description: "This is the description two"},
      {img : "logo", title: "Product Three", description: "This is the description three"}
      ]
    },
    {name : "Developers", dropdownItemData : [
      {img : "logo", title: "Documentaion", description: "Read through the structured docs."},
      {img : "logo", title: "Blog", description: "Visit our blog page for more details."},
      // {img : "logo", title: "Service Three", description: "This is the description three"},
      // {img : "logo", title: "Product Two", description: "This is the description two"},
      // {img : "logo", title: "Product Three", description: "This is the description three"},
      // {img : "logo", title: "Service One", description: "This is the description one"},
      // {img : "logo", title: "Service Two", description: "This is the description two"},
      // {img : "logo", title: "Service Three", description: "This is the description three"},
      // {img : "logo", title: "Product Two", description: "This is the description two"},
      // {img : "logo", title: "Product Three", description: "This is the description three"}
     ]
    }
  ];



let data = [
    {name : "Documentation", dropdownItemData : [
      {img : "logo", title: "Docs", description: "This is the description one"},
      {img : "logo", title: "Tutorial", description: "This is the description two"},
      {img : "logo", title: "Reference", description: "For further reference."}
      ]
    },
    {name : "Blogs", dropdownItemData : [
      {img : "logo", title: "Visit Blog", description: "This is the description one"},
      // {img : "logo", title: "Service Two", description: "This is the description two"},
      // {img : "logo", title: "Service Three", description: "This is the description three"}
     ]
    }
  ]


  export {dropdownData, data}; 